export { useThemeColours as default, useDefaultTheme } from 'components/shared/colours';
